import { render } from "./ConversationsView.vue?vue&type=template&id=d5626878&scoped=true"
import script from "./ConversationsView.vue?vue&type=script&lang=js"
export * from "./ConversationsView.vue?vue&type=script&lang=js"

import "./ConversationsView.vue?vue&type=style&index=0&id=d5626878&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5626878"]])

export default __exports__